const types = {
	automatic: 'automatic',
	manual: 'manual'
};

const locale = {
	ru: {
		automatic: 'автоматическая',
		manual: 'ручная'
	},
	en: types,
	uk: types,
	de: {
		automatic: 'automatisch',
		manual: 'händisch'
	},
	vi: types,
	th: {
		automatic: 'อัตโนมัติ',
		manual: 'ด้วยมือ ทำเอง'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/payout-system-types.js